import { Component, OnInit, OnDestroy } from '@angular/core';
import { MainnavService, ViewType } from '../mainNav/mainnav.service';
import { ImpressumTermViewModel } from '../../shared/models';
import { Router } from '@angular/router';
import { BottomSheetHelperService } from '../../services/bottomSheetHelper.service';
import { CookiePolicyComponent } from '../../modalDialogs/cookiePolicy/cookiePolicy.component';
import { LicenseDialogComponent } from '../../modalDialogs/licenseDialog/licenseDialog.component';
import { AccessibiltyDialogComponent } from '../../modalDialogs/accessibiltyDialog/accessibiltyDialog.component';
import { LanguageDialogComponent } from '../../modalDialogs/languageDialog/languageDialog.component';
import { CoreCOMService } from '../../services/com.service';
import { ExternalLinksSettingsService } from '../../services/ExternalLinksSettings.service';
import { CoreLogService } from '../../services/log.service';
import { WebShopService } from '../../services/webShop.service';
import { NavigationRoute } from '../../shared/enums/navigation-route.enum';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'ya-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss']
})
export class MainFooterComponent implements OnInit, OnDestroy {
  public now: moment.Moment = moment();
  public isMobile: boolean;
  public isSmallView: boolean = false;
  private _viewTypeSubscription: Subscription;
  private _isRevokeEnabled: boolean = false;

  public get paymentoptions() {
    return this._mainnavService.paymentoptions;
  }
  public get communities() {
    return this._mainnavService.communities;
  }
  public get version(): string {
    return this._mainnavService.version;
  }
  public get company_name(): string {
    return this._mainnavService.company_name;
  }
  public get terms(): ImpressumTermViewModel[] {
    return this._mainnavService.terms;
  }
  public get isAccessibilityModeActive(): boolean {
    return this._mainnavService.isAccessibilityModeActive;
  }
  public get canSelectLanguage(): boolean {
    return this._mainnavService.canSelectLanguage;
  }
  public get currentLocale(): string {
    return this._mainnavService.currentLocale;
  }
  /** Returns whether the revoke-order feature is enabled for this tenant. */
  public get isRevokeEnabled(): boolean {
    const me = this;
    return me._isRevokeEnabled;
  }

  constructor(
    private _mainnavService: MainnavService,
    private _router: Router,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _coreCOMService: CoreCOMService,
    private _externalLinksSettingsService: ExternalLinksSettingsService,
    private _coreLogService: CoreLogService,
    private _webShopService: WebShopService,
  ) {
    this.isMobile = this._coreCOMService.environment.client.isMobile;
  }

  ngOnInit() {
    const me = this;
    me.isSmallView = (me._mainnavService.viewType === ViewType.Small);
    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.isSmallView = (viewType === ViewType.Small);
    });
    me._webShopService.getWebshopSettingsDataModel()
      .then((settings) => {
        me._isRevokeEnabled = settings.use_withdrawal !== undefined && settings.use_withdrawal !== null
          ? settings.use_withdrawal
          : true;
      })
      .catch((error) => {
        me._coreLogService.error('MainFooterComponent.ngOnInit', 'getWebshopSettingsDataModel', error);
      });
  }

  ngOnDestroy() {
    const me = this;
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
  }

  public openCookieDialog() {
    const me = this;
    me._bottomSheetHelperService.open(CookiePolicyComponent);
  }

  public openLicenseDialog() {
    const me = this;
    me._bottomSheetHelperService.open(LicenseDialogComponent);
  }

  public openAccessibiltyDialog() {
    const me = this;
    me._bottomSheetHelperService.open(AccessibiltyDialogComponent);
  }

  public openLanguageDialog() {
    const me = this;
    me._bottomSheetHelperService.open(LanguageDialogComponent);
  }

  /** Navigates to the revoke-order page. */
  public navigateToRevokeOrder(): void {
    const me = this;
    me._router.navigate([NavigationRoute.RevokeOrder]);
  }

  public navigateToTerms(termID: number) {
    const me = this;
    me._router.navigate(['/termcondition', termID]);
  }

  public openExternalUrl(url: string): void {
    const me = this;
    me._externalLinksSettingsService.RouteToExternalLinks(url, true)
      .then(() => {/* run async  */ })
      .catch(error => {
        me._coreLogService.error("MainFooterComponent.openExternalUrl", "RouteToExternalLinks (catch)", error);
      });
  }
}
